/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable eqeqeq */
import { Button, Container, Grid } from '@mui/material';
import React from 'react';

// import styles
import { useNavigate } from 'react-router-dom';
import useStyles from '../../assets/styles/components/mianShop';

// import icon svg
import { ReactComponent as IconCashBack } from '../../assets/images/svg/user/cashback.svg';
import { ReactComponent as IconStar } from '../../assets/images/svg/shops/icone_star_1.svg';
import { ReactComponent as IconTime } from '../../assets/images/svg/shops/icon_time.svg';
import { ReactComponent as IconMotocycle } from '../../assets/images/svg/shops/icon_moto.svg';
import { ReactComponent as IconRating0 } from '../../assets/images/svg/menu_shop/icon_avaliaccoes_0.svg';
import { ReactComponent as IconInfo0 } from '../../assets/images/svg/menu_shop/icon_informacoes_0.svg';
import { ReactComponent as IconProduct0 } from '../../assets/images/svg/menu_shop/icon_produtos_0.svg';

import { useShopContext } from '../../providers/use-shop';
import { FormatPrice } from '../../helpers/utils/Formating';

const MainShop: React.FC = () => {
  const { data } = useShopContext();
  const navegate = useNavigate();

  const handleToPage = (url: string) => {
    return navegate(url);
  };

  const classeStyle = useStyles();

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      {data.shop && (
        <>
          <Grid container justifyContent="flex-start">
            <Grid container className={classeStyle.gridShopMain}>
              <img
                src={`${process.env.REACT_APP_API_IMG}${data.shop.dsImagem}`}
                alt="banner"
                className={classeStyle.bannerShopMain}
              />
              <Grid container justifyContent="left">
                {data.shop.flgFechado == 0 ? (
                  <p className={classeStyle.textTagLive}>Aberto</p>
                ) : (
                  <p
                    style={{ backgroundColor: '#a51713' }}
                    className={classeStyle.textTagLive}
                  >
                    Fechado
                  </p>
                )}
              </Grid>
            </Grid>

            <Grid
              item
              justifyContent="left"
              alignItems="center"
              textAlign="left"
              className={classeStyle.gridDescription}
            >
              <Grid className={classeStyle.gridDescriptionsMain}>
                <h3 className={classeStyle.titleShop}>{data.shop.dsNome}</h3>
                <Grid marginTop="5px">
                  {data.shop.vlMinimo != '0.00' &&
                    data.shop.flgFechado == '0' && (
                      <p className={classeStyle.textShop}>
                        Valor mínimo: R$ {FormatPrice(data.shop.vlMinimo)}
                      </p>
                    )}
                  {data.shop.dsCategoria != '' &&
                    data.shop.vlMinimo == '0.00' && (
                      <p className={classeStyle.textShop}>
                        {data.shop.dsCategoria}
                      </p>
                    )}
                  {(data.shop.flgFechado == '1' &&
                    data.shop.horarios[0].horaAbre == '') ||
                  data.shop.horarios[0].horaAbre == null ? (
                    <p className={classeStyle.textShop}>Não abrirá hoje.</p>
                  ) : data.shop.flgFechado != '0' ? (
                    data.shop.horarios.map((hrs: any, index: number) => (
                      <p className={classeStyle.textShop} key={index}>
                        Hoje das {hrs.horaAbre} às {hrs.horaFecha}
                      </p>
                    ))
                  ) : (
                    ''
                  )}
                </Grid>
              </Grid>

              <Grid
                container
                item
                justifyContent="space-between"
                padding="0px 12px 0 0"
                alignItems="center"
                textAlign="center"
                margin="15px 0"
                className={classeStyle.gridAboutMain}
              >
                <Grid className={classeStyle.gridAbout}>
                  <IconTime />
                  <p className={classeStyle.textAbout}>{data.shop.dsTempo}</p>
                </Grid>
                <Grid className={classeStyle.gridAbout}>
                  {data.shop.vlMedia && (
                    <>
                      <IconStar />
                      <p className={classeStyle.textAbout}>
                        {FormatPrice(data.shop.vlMedia)}
                      </p>
                    </>
                  )}
                </Grid>
                {data.shop.vlEntrega && (
                  <Grid className={classeStyle.gridAbout}>
                    <IconMotocycle />
                    <p className={classeStyle.textAbout}>
                      {data.shop.vlEntrega != -1
                        ? `${data.shop.vlEntrega.split('/')[0]}`
                        : 'Gratis'}
                    </p>
                  </Grid>
                )}
                {data.shop.flgCashBack == 1 && (
                  <Grid className={classeStyle.gridAbout}>
                    <IconCashBack height={19} width={19} />
                    <p className={classeStyle.textAbout}>CashBack</p>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>

          <Grid container item justifyContent="center">
            <Grid
              textAlign="center"
              justifyContent="space-between"
              padding="5px 22px"
              alignItems="center"
              marginBottom="10px"
              container
            >
              <Grid>
                <Button
                  style={{ padding: 0 }}
                  onClick={() =>
                    handleToPage(
                      `/shop/detail/list/product/subcategorie/${window.btoa(
                        data.shop.idRestaurante,
                      )}`,
                    )
                  }
                >
                  <IconProduct0 className={classeStyle.iconProduct} />

                  <p className={classeStyle.textBtn}>Produtos</p>
                </Button>
              </Grid>
              <Grid>
                <Button
                  style={{ padding: 0 }}
                  onClick={() =>
                    handleToPage(
                      `/shop/detail/rating/${window.btoa(
                        data.shop.idRestaurante,
                      )}`,
                    )
                  }
                >
                  <IconRating0 className={classeStyle.iconProduct} />

                  <p className={classeStyle.textBtn}>Avaliações</p>
                </Button>
              </Grid>
              <Grid>
                <Button
                  style={{ padding: 0 }}
                  onClick={() =>
                    handleToPage(
                      `/shop/detail/abount/${window.btoa(
                        data.shop.idRestaurante,
                      )}`,
                    )
                  }
                >
                  <IconInfo0 className={classeStyle.iconProduct} />

                  <p className={classeStyle.textBtn}>Informações</p>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </Container>
  );
};
export default MainShop;
